import { useState } from 'react'

import { EMPTY_FUNCTION_ASYNC } from '../../../../constants/common'
import { UserProfileWidgetPersonalInfo } from '../../../User'
import { Component, ComponentProps } from '../../Component'
import { boolean, controls, json } from '../../Controls'
import { MOCK_INFO_OPTIONS } from '../InhabitantProfile.constants'

import {
  PROFILE_PERSONAL_INFO_INHABITANT_DATA,
  PROFILE_PERSONAL_INFO_INHABITANT_FIELD_VARIABLES,
} from './ProfilePersonalInfoWidgetInhabitant.constants'

function ProfilePersonalInfoWidgetInhabitant() {
  const [props, setProps] = useState(() =>
    controls() //
      .add(boolean('canEdit', true))
      .add(json('data', PROFILE_PERSONAL_INFO_INHABITANT_DATA))
      .add(
        json('fieldVariables', PROFILE_PERSONAL_INFO_INHABITANT_FIELD_VARIABLES)
      )
      .add(boolean('isSkeleton', false))
      .add(json('options', MOCK_INFO_OPTIONS))
  )

  return (
    <>
      <Component
        {...props.getValues()}
        Component={UserProfileWidgetPersonalInfo}
        name='UserProfileWidgetPersonalInfo'
        onSubmit={EMPTY_FUNCTION_ASYNC}
      />
      <ComponentProps
        name='UserProfileWidgetPersonalInfo'
        value={props}
        onChange={setProps}
      />
    </>
  )
}

export default ProfilePersonalInfoWidgetInhabitant
